import React, { useState } from "react";

const FAQSection = () => {
  // State to track which accordion is open (null = all closed)
  // We use an ID system to ensure only one opens at a time (optional)
  const [activeId, setActiveId] = useState("faq-0");

  const toggleAccordion = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Expanded Data List for better SEO
  const faqData = [
    {
      id: "faq-0",
      question: "How do I register as a candidate?",
      answer: "Simply click on the 'Register' button at the top right, select 'Candidate', and fill in your details. You can then upload your resume and start applying immediately."
    },
    {
      id: "faq-1",
      question: "Is this job portal free to use?",
      answer: "Yes! For job seekers, searching and applying for jobs is completely free. Employers may have different pricing plans for premium job postings and featured listings."
    },
    {
      id: "faq-2",
      question: "How can I contact an employer?",
      answer: "Once you apply for a job, your profile is sent to the employer. If shortlisted, they will contact you directly via the email or phone number provided in your resume. We prioritize privacy and do not display contact info publicly."
    },
    {
      id: "faq-3",
      question: "Can I edit my application after submitting?",
      answer: "Currently, applications cannot be edited once sent to ensure data integrity for the employer. Please review your details and resume version carefully before clicking 'Apply'."
    },
    // --- NEW SECTIONS ---
    {
      id: "faq-4",
      question: "How does the Resume Parsing work?",
      answer: "Our system uses an advanced Applicant Tracking System (ATS). When you upload your PDF or DOCX, we automatically extract your skills and experience to match you with the best jobs."
    },
    {
      id: "faq-5",
      question: "Is my personal data safe?",
      answer: "Absolutely. We are GDPR compliant and use bank-grade encryption to store your personal details. Your contact information is only shared with employers you explicitly apply to."
    },
    {
      id: "faq-6",
      question: "Can I set up Job Alerts?",
      answer: "Yes! Go to your dashboard and select 'Job Alerts'. You can choose specific keywords, locations, and salary ranges. We will email you daily or weekly when new matches are found."
    },
    {
      id: "faq-7",
      question: "What if I forget my password?",
      answer: "Click on 'Login' and select 'Forgot Password'. Enter your registered email address, and we will send you a secure link to reset your credentials instantly."
    }
  ];

  // Split data into two columns for the layout
  const midPoint = Math.ceil(faqData.length / 2);
  const leftColumn = faqData.slice(0, midPoint);
  const rightColumn = faqData.slice(midPoint);

  // Reusable Accordion Item Component
  const AccordionItem = ({ item }) => {
    const isOpen = activeId === item.id;
    return (
      <div className="accordion-item border mb-3 shadow-sm rounded overflow-hidden">
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={() => toggleAccordion(item.id)}
            style={{ fontWeight: "600", color: isOpen ? "#fb5d16" : "#2B3940" }}
          >
            {item.question}
          </button>
        </h2>
        <div
          className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
          style={{ transition: "all 0.3s ease" }}
        >
          <div className="accordion-body text-muted">
            {item.answer}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid py-5">
      <div className="container">
        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Frequently Asked Questions
        </h1>
        <div className="row g-4">
          {/* Left Column */}
          <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="accordion">
              {leftColumn.map((item) => (
                <AccordionItem key={item.id} item={item} />
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="accordion">
              {rightColumn.map((item) => (
                <AccordionItem key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;